// extracted by mini-css-extract-plugin
module.exports =  {"button":"gAZWzj0"};